import { UserDataType } from '@app-types/PageType'

export const kuranTypes: Record<UserDataType['kuranType'], string> = {
  default: "Standart Kur'an",
  mealli: 'Mealli Kuran',
  hayrat: 'Hayrat Vakfı',
  learning: 'Ögrenme Modu',
  'only-meal': 'Sadece Meal',
}

export { contentLibrary } from './contentLibrary'

export const TOTAL_QURAN_VERSES = 6236
